import Permatahijau1 from "./permatahijau (1).webp";
import Permatahijau2 from "./permatahijau (2).webp";
import Permatahijau3 from "./permatahijau (3).webp";
import Permatahijau4 from "./permatahijau (4).webp";
import Permatahijau5 from "./permatahijau (5).webp";

const permatahijau = [
  Permatahijau1,
  Permatahijau2,
  Permatahijau3,
  Permatahijau4,
  Permatahijau5,
];

export default permatahijau;
